<script>
import { Line, mixins } from "vue-chartjs"
const { reactiveProp } = mixins

export default {
   name: "MetricChart",
   extends: Line,
   mixins:[reactiveProp],
   data() {
      return {
         options: {
            tooltips: {
               callbacks: {
                  label: function(tooltipItems) {
                     return tooltipItems.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  }
               }
            },
            scales: {
               yAxes: [{
                  ticks: {
                     beginAtZero: true,
                     callback: function(value) {
                        let label = "";
                        if((value/1000000000) >= 1) {
                           label = (value/1000000000) + "B";
                        } else if((value/1000000) >= 1) {
                           label = (value/1000000) + "M";
                        } else if((value/1000) >= 1) {
                           label = (value/1000) + "K";
                        } else {
                           label = value;
                        }
                        return label;
                     }
                  },
                  gridLines: {
                     display: true,
                     drawBorder: true,
                     drawOnChartArea: true
                  }
               }],
               xAxes: [
                  {
                     id:"xAxis1",
                     type:"category",
                     ticks: {
                        callback:function(label) {
                           let label_value = label;
                           if(label.indexOf(":") >= 0) {
                              label_value = label.split(":")[1];
                           }
                           return label_value;
                        }
                     },
                     gridLines: {
                        display: true,
                        drawBorder: true,
                        drawOnChartArea: true
                     }
                  },
                  {
                     id:"xAxis2",
                     type:"category",
                     ticks: {
                        callback:function(label) {
                           let label_value = "";
                           if(label.indexOf(":") >= 0) {
                              let month = label.split(":")[1];
                              if(month.toLowerCase() == "jan") label_value = label.split(":")[0];
                           }
                           return label_value;
                           // var node = label.split(";")[1];
                           // var display = label.split(";")[2];
                           // if(display == 1) {
                           //    return node;
                           // } else {
                           //    return "";
                           // }
                        },
                        fontSize: 15,
                        fontStyle: "bold"
                     },
                     gridLines: {
                        drawOnChartArea: false
                     }
                  }
                  // ,
                  // {
                  //    gridLines: {
                  //       display: true,
                  //       drawBorder: true,
                  //       drawOnChartArea: false
                  //    },
                  //    scaleLabel: {
                  //       display: true,
                  //       labelString: 'Month'
                  //    }
                  // }
               ]
            },
            legend: {
               display: true,
               labels: {
                  fontStyle: 'bold'
               }
            },
            responsive: true,
            maintainAspectRatio: false
         }
      }
   },
   computed: {
      computedChartData() {
         // let data = this.chartData;
         // data.labels = this.yAxesLabels;
         // console.log(data);
         // return data;
         return this.chartData;
      }
   },
   mounted() {
      // this.chartData.labels = this.yAxesLabels;
       console.log(this.computedChartData);
      this.renderChart(this.computedChartData, this.options);
   }
}
</script>